<template>
  <v-image
    ref="image"
    :config="{
      image: image,
      ...config,
    }"
  />
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
    },
    imageUrl: String,
  },
  data() {
    return {
      image: null,
    };
  },
  watch: {
    imageUrl() {
      this.getImage();
    },
  },
  created() {
    this.getImage();
  },
  methods: {
    getImage() {
      var image = new window.Image();
      image.src = this.imageUrl;
      image.onload = () => {
        // set image only when it is loaded
        this.image = image;
      };
    },
  },
};
</script>
